// extracted by mini-css-extract-plugin
module.exports = {"personalWrapper":"Personal_personalWrapper_5yF50"};